<template>
  <div class="flex flex-row gap-2">
    <InfuseTag v-if="request.targetOrganisationId" :inline="true">
      <font-awesome-icon :icon="['fal', 'cube']" class="mr-2" />
      <span>{{ organisation?.name ?? '...' }}</span>
    </InfuseTag>

    <InfuseTag v-else-if="request.targetTenantId" :inline="true">
      <font-awesome-icon :icon="['fal', 'cubes']" class="mr-2" />
      <span>{{ tenant?.name ?? '...' }}</span>
    </InfuseTag>
  </div>
</template>

<script setup lang="ts">
import { AccessRequest } from '@infuse/api/iam/access-request';
import { useOrganisation } from '@infuse/iam/organisation/queries';
import { useTenant } from '@infuse/iam/tenant/queries';
import { InfuseTag } from '@infuse/ui/components';
import { watchEffect } from 'vue';

const props = defineProps<{
  request: AccessRequest;
}>();

const { organisation, fetchOrganisationId } = useOrganisation();
const { tenant, fetchTenantId } = useTenant();

watchEffect(() => {
  fetchOrganisationId.value = props.request.targetOrganisationId;
  fetchTenantId.value = props.request.targetOrganisationId ? undefined : props.request.targetTenantId;
});
</script>
